import { OrganizationDataRecipientDto } from "../../../../common/service/server/dto/OrganizationDataRecipientDto";
import { getAggregatedVendorManagedSharingVendors } from "../../../surveys/sharingSurvey";
import { VendorCategory } from "../../../types/Vendor";

export const SELLING_AND_SHARING_SURVEY_NAME = "selling-and-sharing-survey";

export const getVendorsByCategory = (
  vendors: OrganizationDataRecipientDto[],
  category: VendorCategory,
): OrganizationDataRecipientDto[] => vendors.filter((v) => v.category == category);

export const getSelectedUploadingVendors = (answers: Record<string, string>): string[] =>
  JSON.parse(answers["vendor-upload-data-selection"] || "[]");

export const getVendorManagedAdNetworksIds = (answers: Record<string, string>): string[] =>
  getAggregatedVendorManagedSharingVendors(answers);
